import Footer from "../Footer/Footer";
import Header from "../Header/Header";

import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockSubtitle from "../Block/BlockSubtitle";
import BlockText from "../Block/BlockText";
import BlockButton from "../Block/BlockButton";
import Block from "../Block/Block";
import { useNavigate } from 'react-router-dom';

function CVMP2023() {
    const navigate = useNavigate();
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
          <BlockTitle>Color Transfer of 3D Point Clouds For XR Applications</BlockTitle>
          <BlockSubtitle>IEEE International Conference on 3D Immersion, Brussels, Belgium, Dec. 8, 2021.</BlockSubtitle>
          <BlockText>Herbert Potechius, Thomas Sikora, Sebastian Knorr</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Abstract</BlockSubtitle>
            <BlockText>In this paper, we analyse and compare four different color transfer algorithms, which were originally developed for 2D images, for 3D point clouds. In particular, we transfer the color distribution of a given reference 3D point cloud to a source 3D point cloud in order to change the illumination of the scene. Color transfer of 3D models might become an important task in AR and VR applications where e.g., an existing 3D model needs to be updated in real-time according to scene changes like displaced objects and illumination changes. In order to better compare the results of the color transfer algorithms, we created a data set of 3D point clouds consisting of reconstructions of an indoor scene under different lighting conditions, and applied two comparison methods for an objective evaluation, namely histogram comparison and voxel comparison, which will be described in detail in this paper.</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="400px 400px 400px">
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open("https://ieeexplore.ieee.org/document/9687162")}>Paper</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton disabled onClick={() => window.open("https://ieeexplore.ieee.org/document/9687162")}>arXiv</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton onClick={() => navigate('/Projects/Datasets/HueBedroom')}>Dataset</BlockButton>
        </BlockContent>
      </Block>



      <Footer/>
    </div>
  );
}

export default CVMP2023;
